const inyectDataReviews = (rate, totalComments, title, percent) => {
  if (totalComments > 0) {
    const elementRate = document.querySelector("#review-rate");
    const reviewsComments = document.querySelector("#reviews-comments");
    const reviewTitle = document.querySelector("#reviews-title");
    const reviewPercent = document.querySelector("#review-percent");
  
    elementRate.innerHTML = `${rate.toFixed(1)}/5`;
    reviewsComments.innerHTML = `Basado en ${totalComments} comentarios`;
    reviewTitle.innerHTML = title;
    reviewPercent.innerHTML = `${percent.toString().split(".")[0]}% de los comentarios`
  } else {
    const button = document.querySelector(".see_all_yotpo");
    const button2 = document.querySelector(".write-review-button");
    const alternativeMessage = document.querySelector("#alternativeMessage").value;
    const container = document.querySelector(".reviews-content");
    const snipperStar = document.querySelector(".yotpo.bottomLine.yopo-stars-container .yotpo-stars");

    button.classList.add("hidde");
    button2.classList.add("main_button");
    snipperStar.classList.add("hidde");
    container.innerHTML = `<h3> ${alternativeMessage} </h3>`;
  }
}

const findMostFrequent = (arr) => {
  let counts = {};
  let maxValue = arr[0];
  let maxCount = 1;

  for (let i = 0; i < arr.length; i++) {
    let value = arr[i];
    if (counts[value] === undefined) {
      counts[value] = 1;
    } else {
      counts[value]++;
    }
    if (counts[value] > maxCount) {
      maxCount = counts[value];
      maxValue = value;
    }
  }
  return {maxValue, counts}
}

const getDataReviews = async () => {
  const product_id = document.querySelector("#product_id_reviews").value;
  const app_key = "v4og4QfoJAvPN604zsmbu0EMVclMytoYNCY5hriK"

  try {
    const response = await fetch(`https://api.yotpo.com/v1/widget/${app_key}/products/${product_id}/reviews.json`);
    const data = await response.json();
    const question_id = document.querySelector("#reviews-section").getAttribute("data-yotpo-questionid");

    let sizeTitles = []
    data.response.reviews.forEach(element => {
      if(element.custom_fields != null) {
        if (element.custom_fields[question_id]) {
          sizeTitles.push(element.custom_fields[question_id].value)
        }
      }
    });
    
    title = findMostFrequent(sizeTitles).maxValue;
    const count = findMostFrequent(sizeTitles).counts[title] * 100 / data.response.reviews.length
    switch (title) {
      case 0:
        title = "Ajustada";
        break;
      case 1:
        title = "Poco ajustada";
        break;
      case 2:
        title = "Talla adecuada";
        break;
      case 3:
        title = "Poco Holgada";
        break;
      case 4:
        title = "Holgada";
      break;
      default:
        break;
    }
                
    inyectDataReviews(data.response.bottomline.average_score, data.response.bottomline.total_review, title, count);
  } catch (error) {
    console.error(error);
  }
}

const insertButtonSeeAll = (observer) => {
  const parent = document.querySelector(".yotpo-label.yotpo-small-box");
  const element = document.querySelector(".yotpo-nav-content");
  const moveTo = document.querySelector(".main-widget.yotpo-display-wrapper .yotpo-display-wrapper")

  moveTo.after(parent);

  element.classList.add("hidde")
  element.previousElementSibling.classList.add("hidde")

  const template = `
    <button class="see_all_yotpo">
      Ver todos los comentarios
    </button>
  `
  parent.insertAdjacentHTML("afterbegin", template);

  const button = document.querySelector(".see_all_yotpo");

  button.addEventListener("click", ()=> {
    pdpEventsClick('ver todos los comentarios','','','')

    const formWriteReview = document.querySelector(".write-review-wrapper.write-form");

    element.classList.toggle("hidde")
    element.previousElementSibling.classList.toggle("hidde")

    if(formWriteReview.classList.contains("visible") && !element.classList.contains("hidde")) {
      formWriteReview.classList.remove("visible");
      formWriteReview.style = "";
    }

    if(!element.classList.contains("hidde")) {
      element.scrollIntoView();
    }
  })

  datalayerReviewButton()

  observer.disconnect();
}

const insertElements = (mutationList, observer) => {
  for (const mutation of mutationList) {
    if (mutation.type === 'childList') {
      const buttonSeeAll = document.querySelector(".see_all_yotpo");

      if(buttonSeeAll === null) {
        insertButtonSeeAll(observer);
        getDataReviews();
      }
    }
  }
}

const observeElements = () => {
  const element = document.querySelector(".yotpo.yotpo-main-widget");
  const reviewsConfig = { attributes: true, childList: true, subtree: true };
  
  const observerReviews = new MutationObserver(insertElements);
  
  
  observerReviews.observe(element, reviewsConfig);
}

const datalayerReviewButton = () => {

  document.querySelector(".yotpo-default-button.yotpo-icon-btn.pull-right.yotpo-hidden-mobile.write-button.write-review-button .yotpo-icon-button-text").addEventListener("click", ()=> {
    pdpEventsClick('Escribe un comentario','','','')
  })
}

observeElements();